import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  loaderContainer: {
    height: 600,
  },
  loadingInnerContainer: {
    width: 300,
  },
  loadingText: {
    alignSelf: 'center',
  },
}));
